export enum SOCKET_UPDATES {
  reminder = 'reminderInboxUpdate',
  notification = 'notificationInboxUpdate',
}
